import { Route, Routes } from 'react-router-dom';
import { GuestPaymentRouter, InvoiceDashboardRouter } from '@melio/ar-app';
import { FeatureFlags, useFeature } from '@melio/platform-feature-flags';

import { NotFoundScreen } from '@/screens/error-screens/NotFound.screen';
import { useResetAccessToken } from '../../../hooks/session.hooks';
import { DashboardLayout } from '../../layouts/Dashboard.layout';
import { WithAnonymousInitialData, WithInitialData } from '../../utils';

export const ARRouter = () => {
  const [arDashboardEnabled] = useFeature(FeatureFlags.ARDashboard, false);

  return arDashboardEnabled ? (
    <Routes>
      <Route
        path="meliome/*"
        element={
          <GuestPaymentRouter
            WithAnonymousInitialData={WithAnonymousInitialData}
            useResetAccessToken={useResetAccessToken}
          />
        }
      />
      <Route
        path="*"
        element={<InvoiceDashboardRouter DashboardLayout={DashboardLayout} WithInitialData={WithInitialData} />}
      />
    </Routes>
  ) : (
    <NotFoundScreen />
  );
};
